import { render, staticRenderFns } from "./SectionFire.vue?vue&type=template&id=cb8e0680&scoped=true"
import script from "./SectionFire.vue?vue&type=script&lang=js"
export * from "./SectionFire.vue?vue&type=script&lang=js"
import style0 from "./SectionFire.vue?vue&type=style&index=0&id=cb8e0680&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb8e0680",
  null
  
)

export default component.exports